import {
  defaultWorkplaceAnalyticsFeatureFlagValue,
  type WorkplaceAnalyticsFeatureFlagValue,
} from "@clipboard-health/flag-backend-main";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useWorkplaceAnalyticsFlag(): WorkplaceAnalyticsFeatureFlagValue {
  return useCbhFlag(CbhFeatureFlag.WORKPLACE_ANALYTICS_TABLES, {
    defaultValue: defaultWorkplaceAnalyticsFeatureFlagValue,
  });
}
